
export default {
    namespaced: true,
    state: {
        dictionaryData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        typeList: [],
        categoryList: [],
        isSendingSAVE: false,
        timerSAVE: null,
        existChange: false,
        selectedType: 'en_ru',
        params: {
            search: null,
            sort: {
                dir: 'asc',
                field: 'id'
            }
        },
        deletedList: []
    },
    getters: {
        GET_PREPARE_PARAMS: state => {
            return {
                'page': state.currentPage,
                'pageSize': state.perPage <= 0 ? 1 : state.perPage,
                'search': state.params.search,
                'sort': state.params.sort.field,
                'sortDir': state.params.sort.dir
            };
        },
        DELETED_LIST: state => {
            return state.deletedList;
        },
        PARAMS: state => {
            return state.params;
        },
        SELECTED_TYPE: state => {
            return state.selectedType;
        },
        EXIST_CHANGE: state => {
            return state.existChange;
        },
        TYPE_LIST: state => {
            return state.typeList;
        },
        CATEGORY_LIST: state => {
            return state.categoryList;
        },
        DICTIONARY_DATA: state => {
            return state.dictionaryData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        }
    },
    mutations: {
        DELETED_LIST: (state, payload) => {
            return state.deletedList = payload;
        },
        ADD_TO_DELETED_LIST: (state, payload) => {
            return state.deletedList.push(payload);
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        SELECTED_TYPE: (state, payload) => {
            return state.selectedType = payload;
        },
        EXIST_CHANGE: (state, payload) => {
            return state.existChange = payload;
        },
        TYPE_LIST: (state, payload) => {
            return state.typeList = payload;
        },
        CATEGORY_LIST: (state, payload) => {
            return state.categoryList = payload;
        },
        DICTIONARY_DATA: (state, payload) => {
            return state.dictionaryData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },

    },
    actions: {
        SAVE: async ({commit, state, dispatch, getters}, payload) => {
            if (state.isSendingSAVE) {
                if (state.timerSAVE != null) {
                    clearTimeout(state.timerSAVE);
                }
                state.timerSAVE = setTimeout(() => {
                    state.timerSAVE = null;
                    dispatch('SAVE', {th: payload.th});
                }, 2000);
            } else {
                let data = {
                    list: state.dictionaryData,
                    type: state.selectedType,
                    deleted: state.deletedList,
                    params: getters.GET_PREPARE_PARAMS
                };
                state.isSendingSAVE = true;
                payload.th.showOverlay ++;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/dictionary',
                    parameter: data,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        state.deletedList = [];
                        commit('DICTIONARY_DATA', responseData.data.list);
                        commit('TOTAL_ROWS', responseData.data.count);
                        commit('EXIST_CHANGE', false);
                    },
                    getResponse: () => {
                        state.isSendingSAVE = false;
                        payload.th.showOverlay --;
                    }
                });
            }
        },
        GET_TYPE: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/dictionary-type',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('TYPE_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_CATEGORY: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/dictionary-category',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('CATEGORY_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_DATA: async ({commit, state, getters}, payload) => {
            let params = getters.GET_PREPARE_PARAMS;
            params = JSON.stringify(params);
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/dictionary/' + state.selectedType +'?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('DICTIONARY_DATA', responseData.data.list);
                    commit('TOTAL_ROWS', responseData.data.count);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }

    }
}